import { atom } from 'jotai';
import { CartDetails, ShopifyCustomer } from 'api/shopifyV2/types';

export const cartIsOpenAtom = atom(false);
cartIsOpenAtom.debugLabel = 'cartIsOpenAtom';

// cart atoms
export const cartAtom = atom<CartDetails | null>(null);
export const isLoadingAtom = atom<boolean>(true);
export const cartErrorAtom = atom<Error | null>(null);
export const cartCountAtom = atom<number>(0);
export const currentCartIdAtom = atom<string | null>(null);

// customer
export const customerAtom = atom<ShopifyCustomer | null>(null);
export const isCustomerLoadingAtom = atom<boolean>(true);
export const customerErrorAtom = atom<Error | null>(null);
